import { primitiveColors } from '../primitives/colors';
import { primitiveShadows } from '../primitives/shadows';
import { SemanticTokens } from '@/core/tokens/designs/types';

export const semanticLight: SemanticTokens = {
	surface: {
		primary: primitiveColors.gray[50],
		secondary: primitiveColors.gray[200],
		tertiary: primitiveColors.gray[300],
		midtone: primitiveColors.gray[400],
		background: primitiveColors.gray[100],
		overlay: primitiveColors.alpha.black25,
	},
	border: {
		default: primitiveColors.gray[300],
		subtle: primitiveColors.gray[200],
		strong: primitiveColors.gray[400],
	},
	text: {
		primary: primitiveColors.gray[500],
		secondary: primitiveColors.gray[400],
		tertiary: primitiveColors.gray[300],
	},
	interactive: {
		default: primitiveColors.gray[200],
		hover: primitiveColors.gray[300],
		pressed: primitiveColors.gray[400],
	},
	status: {
		success: primitiveColors.secondary[600],
		error: primitiveColors.error[500],
		warning: primitiveColors.accent[500],
		info: primitiveColors.primary[500],
	},
	elevation: {
		flat: 'none',
		small: primitiveShadows.light.sm,
		raised: primitiveShadows.light.md,
		overlay: primitiveShadows.light.xl,
		modal: primitiveShadows.light['2xl'],
	},
};

export const semanticDark: SemanticTokens = {
	surface: {
		primary: primitiveColors.grayDark[500],
		secondary: primitiveColors.grayDark[400],
		tertiary: primitiveColors.grayDark[450],
		midtone: primitiveColors.gray[400],
		background: primitiveColors.grayDark[600],
		overlay: primitiveColors.alpha.black25,
	},
	border: {
		default: primitiveColors.grayDark[400],
		subtle: primitiveColors.grayDark[300],
		strong: primitiveColors.gray[400],
	},
	text: {
		primary: primitiveColors.gray[200],
		secondary: primitiveColors.gray[300],
		tertiary: primitiveColors.gray[400],
	},
	interactive: {
		default: primitiveColors.grayDark[400],
		hover: primitiveColors.grayDark[300],
		pressed: primitiveColors.gray[400],
	},
	status: {
		success: primitiveColors.secondary[600],
		error: primitiveColors.error[500],
		warning: primitiveColors.accent[500],
		info: primitiveColors.primary[500],
	},
	elevation: {
		flat: 'none',
		small: primitiveShadows.dark.sm,
		raised: primitiveShadows.dark.md,
		overlay: primitiveShadows.dark.xl,
		modal: primitiveShadows.dark['2xl'],
	},
};
